import React, { useState, useContext, useRef, useEffect } from "react";
import axios from "axios";
import { API } from "../../../../services/api";
import '../../../../css/posOrder.css';
import '../../../../css/BillForKitchen.css';
import { POSContent } from "../pos";
import { UserContext } from "../../../../App";
import backimg from '../../../../img/backimg.jpg';

axios.defaults.baseURL = API;

function PosOrder() {


    const {userID, UserName, LocationID, LocationName, Address, Tell, Role, device, setDevice, status, setStatus,EPSON_VENDOR_ID_T82x, characteristic, setCharacteristic, EPSON_VENDOR_ID,  deviceBluetooht, setDeviceBluetooht, statusBluetooht, setStatusBluetooht} = useContext(UserContext);
    const {setShowPayment, showOrder, TempOrder, setTempOrder, setShowOrder, serverName, QueueID, QueueNumber, setQueueID, 
        setQueueNumber, showSelectSugar, setShowSelectSugar, LaoName, setLaoName, ProductID, setProductID, qty, setqty, 
        Retail_Price, setRetail_Price, EngName, setEngName, ProductType, setProductType,ImgUrl, setImgUrl,
        subTotal, setSubTotal, setNetTotal, NewNetTotal, setNewNetTotal, setTax, showAlert, setShowAlert, setTableList, errorMessage, setErrorMessage} = useContext(POSContent);

    const [menuList, setMenuList] = useState([]);
    const [subMenuList, setSubMenuList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [TakeAway, setTakeAway] = useState("Dine In");
    const [tw, setTw] = useState(false);
    const [PrintCount, setPrintCount] = useState(1);
    const [Barcode, setBarcode] = useState([]);
    const [Quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingDrinkBill, setLoadingDrinkBill] = useState(false);
    const [imageUrl, setImageUrl] = useState('');

    const scrollRef = useRef(null);

    const handleWheel = (e) => {
        if (e.deltaY !== 0) {
        e.preventDefault(); 
            scrollRef.current.scrollLeft += e.deltaY;
        }
    };

    function currencyFormat(num) {
        if (num !== "" && num > 0) {
            return Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
    }

    const connectPrinter = async () => {
            try {
            setStatus('Connecting...');
            
            // Request permission to access the USB device
            const selectedDevice = await navigator.usb.requestDevice({
                filters: [{ vendorId: EPSON_VENDOR_ID }]
            });

            await selectedDevice.open();
            
            // Select configuration (most USB printers use configuration 1)
            if (selectedDevice.configuration === null) {
                await selectedDevice.selectConfiguration(1);
            }
            
            // Claim the primary interface (usually interface 0)
            await selectedDevice.claimInterface(0);

            setDevice(selectedDevice);
            setStatus(`Connected to: ${selectedDevice.productName || 'Epson Printer'}`);
            } catch (error) {
                console.error('USB Connection Error:', error);
                setStatus(`Connection failed: ${error.message}`);
            }
    };

    const connectPrinterviaStickerPrinter = async () => {
          try {
            setStatusBluetooht('Connecting...');
            
            // Request permission to access the USB device
            const selectedDevice = await navigator.usb.requestDevice({
                filters: []
            });

            await selectedDevice.open();
            
            // Select configuration (most USB printers use configuration 1)
            if (selectedDevice.configuration === null) {
                await selectedDevice.selectConfiguration(1);
            }
            
            // Claim the primary interface (usually interface 0)
            await selectedDevice.claimInterface(0);

            setDeviceBluetooht(selectedDevice);
            setStatusBluetooht(`Connected to: ${selectedDevice.productName || 'Epson Printer'}`);
            } catch (error) {
                console.error('USB Connection Error:', error);
                setStatusBluetooht(`Connection failed: ${error.message}`);
            }
    };

    let receipt = '';
    const ESC = '\x1B';
    const GS = '\x1D';
    const CMD = {
        INIT: ESC + '@',             // Initialize printer
        ALIGN_LEFT: ESC + 'a\x00',   // Left alignment
        ALIGN_CENTER: ESC + 'a\x01', // Center alignment
        ALIGN_RIGHT: ESC + 'a\x02',  // Right alignment
        FONT_NORMAL: ESC + '!', // Select normal font (Font A)
        FONT_Size: ESC + '!' + 1,     
        FONT_SizeNomal: ESC + '!' + 0,    
        FONT_BOLD: ESC + 'E\x01',    // Turn on bold
        FONT_REGULAR: ESC + 'E\x00', // Turn off bold
        FEED_CUT: GS + 'V\x41\x03',  // Feed paper and cut (Partial cut)
    };

    const formatLeftRight = (leftText, rightText, maxChars = 48) => {
        const spacesNeeded = maxChars - (leftText.length + rightText.length);
        if (spacesNeeded <= 0) {
        return leftText.substring(0, maxChars - rightText.length - 1) + ' ' + rightText + '\n';
        }
        return leftText + ' '.repeat(spacesNeeded) + rightText + '\n';
    };

    const PrintfoodBillDetail = (i) => {
        setLoading(true);
        let receipt = '';
        let SubTotal = 0;

        // 1. Initialize Printer
        receipt += CMD.INIT;

        // 2. Header Section (Centered)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + 'Manee Arabica Coffee'.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += `${Address}\n`;
        receipt += `Tel: (+856) ${Tell}\n`;
        receipt += '-'.repeat(48) + '\n'; // Divider

        // 3. Metadata Section (Left Aligned)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + 'Food Bill'.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += `${TakeAway}` + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += CMD.ALIGN_LEFT;
        receipt += `Queue NO: ${QueueNumber}\n`;
        receipt += `Date: ${new Date().toLocaleDateString()}\n`;
        receipt +=  '\n';

    

        // 4. Items Loop (Dynamic Columns Formatting)
        receipt += ("Item/Qty                                   Price\n");
        receipt += '='.repeat(48) + '\n';
        const quantityText = `${TempOrder[i].Quantity}x ${currencyFormat(TempOrder[i].Retail_Price)}`;
        const totalText = `${(TempOrder[i].Quantity * TempOrder[i].Retail_Price).toFixed(0)}`;

        // Row 1: Print Item Name (Wrap safely if too long)
        if (TempOrder[i].EngName.length > 47) {
            receipt += TempOrder[i].EngName.substring(0, 47) + '\n';
        } else {
            receipt += TempOrder[i].EngName + '\n';
        }

        // Row 2: Sub-row containing calculated item metrics right aligned
        receipt += formatLeftRight(`  ${quantityText}`, currencyFormat(totalText));
        SubTotal = (Number(TempOrder[i].Retail_Price) * Number(TempOrder[i].Quantity));

        receipt += '-'.repeat(48) + '\n';
        // Bold total row
        receipt += CMD.FONT_BOLD;
        receipt += formatLeftRight("TOTAL:", `${currencyFormat(SubTotal)}`);
        receipt += CMD.FONT_REGULAR;
        receipt += '-'.repeat(48) + '\n';

        // 6. Footer & Auto-Cutg
        receipt += CMD.FEED_CUT;

        TempOrder[i].PrintStatus = "Y";
        TempOrder[i].QuantityPrint = 0;
        localStorage.setItem("TemOrderForViewScreen", JSON.stringify(TempOrder));

        // Convert string to Uint8Array for binary transmission
        const encoder = new TextEncoder();
        const uint8Array = encoder.encode(receipt);
        
        setLoading(false);
        return uint8Array;
    };

    const PrintDrinkBillDetail = (i) => {
        
        setLoadingDrinkBill(true);
        let zpl = '';
        let SubTotal = 0;    
            zpl = `^XA\r\n`;
            zpl += `^PW240\r\n`;  // Print Width = 240 dots (30mm)
            zpl += `^LL160\r\n`;  // Label Length = 160 dots (20mm)
            
            // Centered Title using ^FB (Field Block) to auto-center text at X=0 with width 240
            zpl += `^CF0,24,15\r\n`;
            zpl += `^FO0,15^FB240,1,0,C^FDQueue NO: ${QueueNumber}^FS\r\n`;
            zpl += `^FO20,45^FDDate: ${new Date().toLocaleDateString()}^FS\r\n`;
            // zpl += `^FO0,40^FB240,1,0,C^FDDate: ${new Date().toLocaleDateString()}^FS\r\n`;
            zpl += `^CF0,24,15\r\n`;
            zpl += `^FO20,75^FD${TempOrder[i].EngName}^FS\r\n`;
            if(TempOrder[i].ProductType !== "BAKERY" && TempOrder[i].ProductType !== "Bakery"){
                zpl += `^FO20,105^FDSugar: ${TempOrder[i].Sugar}^FS\r\n`;
            }
            zpl += `^XZ\r\n`;
            TempOrder[i].PrintStatus = "Y";
            TempOrder[i].QuantityPrint = 0;
            localStorage.setItem("TemOrderForViewScreen", JSON.stringify(TempOrder));
        const encoder = new TextEncoder();
        const uint8Array = encoder.encode(zpl);
        
        setLoadingDrinkBill(false);
        return uint8Array;     
    };

    const handlePrintFood = async () => {
        if(device){
            const endpointOut = device.configuration.interfaces[0].alternate.endpoints.find(
                (ep) => ep.direction === 'out' && ep.type === 'bulk'
            );
            const endpointNumber = endpointOut.endpointNumber;

            for (var i=0; i < TempOrder.length; i++) {
                if(TempOrder[i].ProductType == "Food" || TempOrder[i].ProductType == "FOOD"){
                    if( TempOrder[i].PrintStatus == "N"){    
                        for (var n=0; n < TempOrder[i].Quantity; n++) {
                            const rawBuffer = PrintfoodBillDetail(i);
                            device.transferOut(endpointNumber, rawBuffer);
                        }
                    } else {
                        for (var n=0; n < TempOrder[i].QuantityPrint; n++) {
                            const rawBuffer = PrintfoodBillDetail(i);
                            device.transferOut(endpointNumber, rawBuffer);
                        }
                    }
                }
            }
        } else{
            connectPrinter();
        }
    };

    const handlePrintDrink = async () => {
        if(deviceBluetooht){
           
            const endpointOut = deviceBluetooht.configuration.interfaces[0].alternate.endpoints.find(
                (ep) => ep.direction === 'out' && ep.type === 'bulk'
            );
            const endpointNumber = endpointOut.endpointNumber;
            for (var i=0; i < TempOrder.length; i++) {
                if(TempOrder[i].ProductType == "Drink" || TempOrder[i].ProductType == "DRINK" || TempOrder[i].ProductType == "Coffee" || TempOrder[i].ProductType == "COFFEE" || TempOrder[i].ProductType == "Bakery" || TempOrder[i].ProductType == "BAKERY" ){
                    if( TempOrder[i].PrintStatus == "N"){    
                        for (var n=0; n < TempOrder[i].Quantity; n++) {
                            const rawBuffer = PrintDrinkBillDetail(i);
                            await deviceBluetooht.transferOut(endpointNumber, rawBuffer);
                        }
                    } else {
                        for (var n=0; n < TempOrder[i].QuantityPrint; n++) {
                            const rawBuffer = PrintDrinkBillDetail(i);
                            await deviceBluetooht.transferOut(endpointNumber, rawBuffer);
                        }
                    }
                }
            }
        } else {
            connectPrinterviaStickerPrinter();
        }
    };

    const handleInputPrintCount = event => { 
        const { name, value } = event.target;
        setPrintCount(value)
    };

    async function handleClickMenuToGetSubmenu(MenuID) {
        let token = localStorage.getItem("token");
        await axios.get(`/getSubMenuByMenuID/${MenuID}`, { headers: { Authorization: `MR_ADMIN ${token}`}})
        .then((response) => {
          let temOrder = response?.data;
          if(temOrder.length > 0){
            setSubMenuList(temOrder);
            setProductList([]);
          } else {
            setSubMenuList([]);
            setProductList([]);
          }
        }).catch((err) => {
            setSubMenuList([]);
            setProductList([]);
            console.log(err);
        });
    };

    const handleInputChange = event => {
        setQuantity(event.target.value);
    };

    async function handleClickSubMenuToGetProductList (CategoryID) {
        if(CategoryID){
          let token = localStorage.getItem("token");
          await axios.put(`/getProductBySubmenu/${CategoryID}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let temOrder = response?.data;
            if(temOrder.length > 0){
                setProductList(temOrder);
            } else {
                setProductList([]);
            }
          }).catch((err) => {
            setProductList([]);
            console.log(err);
          });
        } else {
            setProductList([]);
        }
    }

    async function addOrder(ProductID, ProductType, Retail_Price, LaoName, EngName, gqty, y, ImgUrl) {
        if(gqty > 0){
            if(ProductType == "Drink" || ProductType == "DRINK" || ProductType == "Coffee" || ProductType == "COFFEE" || ProductType == "SMOOTHIE" || ProductType == "Smoothie"){
                setRetail_Price(Retail_Price);
                setLaoName(LaoName);
                setProductID(ProductID);
                setqty(gqty);  
                setEngName(EngName);
                setProductType(ProductType);
                setShowSelectSugar(true);
                setImgUrl(ImgUrl);
            } else {
                var c =0;
                for (var i=0; i < TempOrder.length; i++) {
                    if (TempOrder[i].ProductID == ProductID) {
                        if(Number(TempOrder[i].Quantity) + Number(gqty) > 0)
                        {
                            TempOrder[i].Quantity = Number(TempOrder[i].Quantity) + Number(gqty);
                            TempOrder[i].SubTotal = Number(TempOrder[i].Quantity) * Number(TempOrder[i].Retail_Price);
                            if(TempOrder[i].PrintStatus === "Y"){
                                if(TempOrder[i].QuantityPrint > 0){
                                    TempOrder[i].QuantityPrint = Number(TempOrder[i].QuantityPrint) + Number(gqty);
                                } else {
                                    TempOrder[i].QuantityPrint = gqty;
                                }
                            } 
                        } else {
                            TempOrder.splice(i, 1);
                        }
                        c = 1;
                        break;
                    }
                }  
                if(c == 0){
                    var datalist = {
                        SubTotal: Retail_Price,
                        ProductID: ProductID,
                        LaoName: LaoName,
                        EngName: EngName,
                        Retail_Price: Retail_Price,
                        Quantity: Number(gqty),
                        StatusID : 1,
                        QuantityPrint : 0,
                        PrintStatus: "N",
                        ProductType: ProductType,
                    }
                    TempOrder.push(datalist);
                }
                localStorage.setItem("TemOrderForViewScreen", JSON.stringify(TempOrder));
                getSubtotal();
            }
        } else {
            for (var i=0; i < TempOrder.length; i++) {
                if (TempOrder[i].ProductID == ProductID && i == y) {
                    if(Number(TempOrder[i].Quantity) + Number(gqty) > 0)
                    {
                        TempOrder[i].Quantity = Number(TempOrder[i].Quantity) + Number(gqty);
                        TempOrder[i].SubTotal = Number(TempOrder[i].Quantity) * Number(TempOrder[i].Retail_Price);
                        if(TempOrder[i].PrintStatus === "Y"){
                            if(TempOrder[i].QuantityPrint > 0){
                                TempOrder[i].QuantityPrint = Number(TempOrder[i].QuantityPrint) + Number(gqty);
                            } else {
                                TempOrder[i].QuantityPrint = gqty;
                            }
                        } 
                    } else {
                        TempOrder.splice(i, 1);
                    }
                    break;
                }
            }  
                localStorage.setItem("TemOrderForViewScreen", JSON.stringify(TempOrder));
                getSubtotal();
        }
        
    }

    async function handleSearchProduct (e) {
        let token = localStorage.getItem("token");
        setBarcode(e.target.value);
        if(e.target.value){
            var data = {
                Barcode: e.target.value
            }
            await axios.post("/getProductByBarcode", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
                let productData = response?.data;
                if(productData.length > 0){
                    addOrder(productData[0].ProductID, productData[0].Retail_Price, productData[0].LaoName, productData[0].EngName, Quantity);
                    setBarcode("");
                }
            }).catch((err) => {
                console.log(err);
            });
        }
    }

    const getSubtotal = () => {
        if (TempOrder) {
          if(TempOrder.length > 0){
                var gSubTotal = 0;
                for (var i=0; i < TempOrder.length; i++) {
                    createTemOrder(i);
                    gSubTotal = Number(gSubTotal) + Number(TempOrder[i].SubTotal);
                }  
                var gNewTax = 0;
                var gtax = (Number(gSubTotal) -((Number(gSubTotal) * 100) /110)).toFixed(2);
                setTax(gtax);
                setSubTotal(gSubTotal);
                setNewNetTotal(gSubTotal);
                setNetTotal(gSubTotal);
                createTempTotal(gSubTotal);
            } else{
                setSubTotal(0);
                setNetTotal(0);
                setNewNetTotal(0);
                setTax(0);
                DeleteTemOrder();
                DeleteTempTotal();
            }
        } else{
            setSubTotal(0);
            setNewNetTotal(0);
            setNetTotal(0);
            setTax(0);
            DeleteTemOrder();
            DeleteTempTotal();
        }
    }

    const handleClickTakeAway = event => {
        if(tw){
            setTakeAway("Dine In");
            setTw(false);
        }else {
            setTakeAway("TakeAway");
            setTw(true);
        }  
    };

    const handleShowPayment = () => {
       if(TempOrder.length > 0){
        setShowPayment(true);
       } else{
            setErrorMessage("ກະລຸນາເລືອກສິນຄ້າກ່ອນ");
            setShowAlert(true);
       }
    }

    async function getMenu() {
        axios
        .get("/getmenu")
        .then((response) => {
            let Data = response?.data;
            setMenuList(Data);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    async function DeleteTemOrder () {
        let token = localStorage.getItem("token");
        let data;
        data = {
            LocationID: LocationID,
        };
        await axios.post("/DeleteTemOrder", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            //success
        }).catch((err) => {
            console.log(err);
        });
    }

    async function createTemOrder (i) {
        let token = localStorage.getItem("token");
        let data;
        data = {
            ProductID: TempOrder[i].ProductID,
            EngName: TempOrder[i].EngName,
            Quantity: TempOrder[i].Quantity,
            Price: TempOrder[i].Retail_Price,
            Total: (TempOrder[i].Quantity * TempOrder[i].Retail_Price),
            LocationID: LocationID,
        };
        await axios.post("/createTemOrder", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            //success
        }).catch((err) => {
            console.log(err);
        });
    }

    async function DeleteTempTotal () {
        let token = localStorage.getItem("token");
        let data;
        data = {
            LocationID: LocationID,
        };
        await axios.post("/DeleteTempTotal", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            //success
        }).catch((err) => {
            console.log(err);
        });
    }

    async function createTempTotal (gSubTotal) {
        let token = localStorage.getItem("token");
        let data;
        data = {
            SubTotal: gSubTotal,
            Discount: 0,
            NetTotal: gSubTotal,
            PaidAmount: 0,
            ChangeAmount: 0,
            MemberNO: "",
            PreviousBalance: 0,
            NewBalance: 0,
            PreviousPoint: 0,
            NewPoint: 0,
            LocationID: LocationID,
        };
        await axios.post("/CreateTempTotal", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            //success
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        getMenu();
        getSubtotal();
      }, []);

    return (
        <div style={{ display: showOrder ? 'flex' : 'none' }} className="formPos">
            <img className="logo" src={backimg} />
            <div className="OrderContent">
                
                <div className="LeftContent">
                    <div className="title">
                        <p>Manee Arabica</p>
                    </div>
                    <div className="SubMenu">
                        {
                            subMenuList && subMenuList.map((x, y) => {
                                return (
                                    <div key={y} className="SubMenuContent" onClick={() => handleClickSubMenuToGetProductList(x.CategoryID)}>
                                        <img src={x.ImgUrl} />
                                        <p className="name">{x.Category}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <div className="CenterContent">
                    <div className="CenterHeader">
                        <div className="user-name">{serverName}</div>
                        <div className="Search">
                            <div className="Barcode">
                                <span>Barcode</span>
                                <input type="text" className="form-control" placeholder="Search" onChange={(e) => handleSearchProduct(e)} value={Barcode} />
                            </div>
                            <div className="Qty">
                                <span>Quantity</span>
                                <input type="text" className="form-control" placeholder="1" onChange={(e) => handleInputChange(e)} value={Quantity}/>
                            </div>
                        </div>
                    </div>
                    <div className="menuContent" ref={scrollRef} onWheel={handleWheel}>
                        {
                            menuList && menuList.map((x, y) => {
                                return (
                                    <div key={y} className="FoodMenu" onClick={() => handleClickMenuToGetSubmenu(x.MenuID, x.ProductType)}>
                                        <div className="FoodMenuContent" tabIndex={y}  >
                                            <div className="item-header">
                                                <img src={x.ImgUrl} className="icon-menu"/>
                                            </div>
                                            <div className="item-body">
                                                <p className="name">{x.ProductType}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {/* <div className="underLine">
                        <hr />
                    </div> */}
                    <div className="MenuList">
                    {
                            productList && productList.map((x, y) => {
                                return (
                                    <div key={y} className="item" onClick={() => addOrder(x.ProductID, x.ProductType, x.Retail_Price, x.LaoName, x.EngName, 1, y, x.ImgUrl)}>
                                        <div className="item-header">
                                            <img src={x.ImgUrl} className="img-product"/>
                                        </div>
                                        <div className="item-body">
                                            <div className="name">
                                                <p>{x.LaoName}</p>
                                            </div>
                                            <p className="price">{currencyFormat(x.Retail_Price)}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <div className="RightContent">
                    <div className="billNo">
                        <div className="ordertext"><p>Order List</p></div>
                        <div className="tableNo"><p>Queue # {QueueNumber} </p></div>
                        <div className="btnclose" onClick={e => setShowOrder(false)} >X</div>
                    </div>
                    <div className="OrderHead">
                        <div className="ProductName"><p>Price</p></div>
                        <div className="Quantity">Quantity</div>
                        <div className="Price">Total</div>
                    </div>
                    <div className="posRightSidenavContent">
                        {
                            TempOrder && TempOrder.map((x, y) => {
                                return (
                                    <div key={y} className="orderContent">
                                        <div className="orderFooter">
                                            <div className="price">
                                                <p>{currencyFormat(x.Retail_Price)}</p>
                                            </div>
                                            <div className="plus" onClick={() => addOrder(x.ProductID, x.ProductType, x.Retail_Price, x.LaoName, x.EngName, 1)}>
                                                +
                                            </div>
                                            <div className="quantity">
                                                <p>{currencyFormat(x.Quantity)}</p>
                                            </div>
                                            <div className="minus" onClick={() => addOrder(x.ProductID, x.ProductType, x.Retail_Price, x.LaoName, x.EngName, -1, y)}>
                                                -
                                            </div>
                                            <div className="Subtotal">
                                                <p>{currencyFormat(x.Quantity * x.Retail_Price)}</p>
                                            </div>
                                        </div>
                                        <div className="orderBody">
                                            <div className="detail">
                                                <div className="productName">
                                                    <span>{y+1}. {x.LaoName} {x.Sugar} %</span>         
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="posRightSidenavBottom">
                        <div className="footer-subtotal">
                            <div className="footer-line"></div>
                            <div className="nettotal">
                                <span>Sutotal:</span>
                                <strong>{currencyFormat(subTotal)}</strong>
                            </div>
                        </div>
                        <div className="paymentMethod">
                            <div className="btnpayment" onClick={(e) => handleShowPayment()}>
                                <span>Payment</span>
                            </div>
                            {/* <div className="btnPrintFood"  onClick={(e) => connectPrinter()}>
                                <span>Connect Printer </span>
                            </div> */}
                            <div className="btnPrintFood"  onClick={(e) => handlePrintFood()}>
                                <span>Print Food </span>
                            </div>
                            <div className="btnPrintDrink" onClick={(e) =>handlePrintDrink()}>
                                <span>Print Drink</span>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="form-check form-check-inline takeAway">
                                <input className="form-check-input" type="radio" name="takeAway" value="TakeAway" onClick={(e) => handleClickTakeAway(e)} checked={tw} />
                                <span className="form-check-label"> TakeAway </span>
                            </label>
                            <div className="headerPrintcount">
                                <span>ຈຳນວນບິນ:</span>
                                <input className="PrintCount" type="text" name="PrintCount" placeholder="1" onChange={(e) => handleInputPrintCount(e)} value={PrintCount} required />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PosOrder;
